import { render, staticRenderFns } from "./ActiveListDetail.vue?vue&type=template&id=04a1b309&scoped=true&"
import script from "./ActiveListDetail.vue?vue&type=script&lang=js&"
export * from "./ActiveListDetail.vue?vue&type=script&lang=js&"
import style0 from "./ActiveListDetail.vue?vue&type=style&index=0&id=04a1b309&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a1b309",
  null
  
)

export default component.exports